import React, { useEffect, useState } from 'react';



const CountryForm : React.FC = () => {
return (
  <div className="country-form-container">
    <h2 style={{ fontSize: '18px' }}>This page is under development</h2>
  </div>
);

 };

export default CountryForm;
